import React, {useEffect, useState} from "react";
import {IWishList} from "../../interfaces";

export interface ISelectWishlistProps {
    wishlists: IWishList[],
    selectedWishlist?: IWishList,
    hidePopup:()=>void,
    submit:  (toWishList:IWishList | null,newWishlistName:string) => void,
    errorMessage:string
}

/**
 * common component for wishlist page and add "to wish list" popup
 */
const SelectWishList = (props:ISelectWishlistProps) => {
    const [toWishList, setToWishList] = useState<IWishList | null>(null);
    const [showNewListInput, setShowNewListInput] = useState(false);
    const [newWishlistName, setNewWishlistName] = useState("");
    const [errorMessage, setErrorMessage] = useState(props.errorMessage);


    const thereIsOneList = props.wishlists.length === 1;
    const actionText =  thereIsOneList? "Create a new list:" : "Select List:";
    const OnSubmit = async () => {
        //if no existing wishlist was selected & there is more than one list
        if(toWishList === null && !showNewListInput && !thereIsOneList){
            setErrorMessage("Please select a list.");
            return;
        }
        //if new wishlist was selected and new list's name is null
        else if(showNewListInput && newWishlistName.length === 0){
            setErrorMessage("This field is required.");
            return;
        }
        setErrorMessage("");
        await props.submit(toWishList,newWishlistName);
    }
    useEffect(() => {

    }, []);
    return (
        <div className="py-4 w-80 p-2">
            <div className="font-bold">{actionText}</div>

            {props.wishlists.map((wishlist,index) => {
                //do not show the current wishlist ( can not move item to the same wishlist )
                if(props.selectedWishlist && wishlist.itemID === props.selectedWishlist.itemID) return "";
                return  <label key={wishlist.purl} className="flex items-center pt-4" onClick={() => {
                    setToWishList(props.wishlists.filter(wsh => wsh.purl === wishlist.purl)[0]);
                    setShowNewListInput(false);
                }}>
                    <input
                        type="radio"
                        name="SelectListRadio"
                        className="mr-2 cursor-pointer"
                        value={ wishlist.purl }
                        checked={ wishlist.purl === toWishList?.purl }
                        onChange={()=>{}}
                    />
                    { wishlist.listName }
                </label>
            })
            }
            {/*if there is only one list -> show input for list creation*/}
            {/*if there is more than one list -> show input only when user clicks "+ create new list"*/}
            {(showNewListInput || thereIsOneList) &&
                <label className="flex items-center pt-4 w-2/3" >
                    {/*show radio button only if there is more than one list*/}
                    {!thereIsOneList &&
                        <input
                            type="radio"
                            name="SelectListRadio"
                            className="mr-2 cursor-pointer"
                            value="new"
                            checked={ showNewListInput }
                            onClick={() => {
                                setShowNewListInput(false);
                                setToWishList(null);
                            }}
                            onChange={()=>{}}
                        />
                    }
                    <input
                        className="text-sm font-normal text-gray-500 py-2 focus:outline-none w-full pl-2 border-b border-gray-250"
                        value={ newWishlistName }
                        autoComplete="off"
                        type="text"
                        placeholder="New List Name..."
                        onChange={evt => {
                            setNewWishlistName(evt.target.value);
                        }}
                        autoFocus
                        maxLength={30}
                        minLength={1}
                    />
                </label>}
            {errorMessage.length > 0 && <div className="text-red w-full pl-2 text-sm">{errorMessage}</div>}

            {/*each user is limited to 10 wish lists*/}
            {!showNewListInput && props.wishlists.length < 10 && props.wishlists.length > 1 &&
                <button
                    type="button"
                    className="flex items-center text-blue-200 mt-4 cursor-pointer" onClick={()=> {
                    setShowNewListInput(true);
                    setErrorMessage("");
                    setToWishList(null);
                }
                }>
                    + New List
                </button>
            }
            <div className="w-full text-right flex text-center mt-8">
                <button
                    type="button"
                    className="px-4 py-2 cursor-pointer"
                    onClick={props.hidePopup}>Cancel
                </button>

                <button
                    type="button"
                    className="w-btn inline-block bg-blue-200 text-white font-normal w-auto px-24" onClick={OnSubmit}>
                    <span>Save</span>
                </button>
            </div>
        </div>

    )
};

export default SelectWishList;